export default {
    title: 'MilkRun',
    icon: 'mdi-cart-arrow-right',
    divider: true,
    groups: ['Laser', 'Admin', 'Amministrazione', 'Tecnici', 'Officina', 'Magazzino', 'Schedulazione', 'Milkrun', 'Tempi&Metodi', 'Qualità'],
    submenu: [
        {title: 'MilkRun', route: {name: 'MilkRunToDo', params: {}}},
        {title: 'Missioni tablet', route: {name: 'MilkRunMissions'}, groups: ['Milkrun', 'Magazzino', 'Amministrazione']},
    ]
}
